import { Components, Theme } from '@mui/material/styles';

export const toastTheme: Components<Theme>['MuiSnackbar'] = {
  // styleOverrides: {},
  // variants: [],
};
